import { colors } from '../../constants/appColors'

// Skill-level color ramp: Beginner (green) → Elite (red). Case-insensitive; an
// unknown/empty value falls back to the neutral text color. Returned values are
// resolved hex strings from appColors so this stays platform-agnostic (mobile
// and web both consume it).
// Dark, saturated stops so each level reads clearly on a light card.
const SKILL_COLOR_BY_VALUE: Record<string, string> = {
  beginner: colors.SUCCESS_400, // deep green  #0b7923
  intermediate: colors.INFO_300, // blue  #3894ff
  advanced: colors.ORANGE_DARK, // burnt orange #c2410c
  elite: colors.ERROR_300, // red         #d91b1b
}

export const getSkillLevelColor = (
  skillLevel?: string | null
): string | undefined => {
  if (!skillLevel) {
    return undefined
  }
  return SKILL_COLOR_BY_VALUE[skillLevel.trim().toLowerCase()]
}

// Per-level MaterialCommunityIcons glyph: a "growth ramp" from sprout to fire.
// Unknown/empty levels keep the neutral speedometer.
const DEFAULT_SKILL_ICON = 'speedometer'
const SKILL_ICON_BY_VALUE: Record<string, string> = {
  beginner: 'sprout',
  intermediate: 'speedometer',
  advanced: 'fire',
  elite: 'crown',
}

export const getSkillLevelIcon = (skillLevel?: string | null): string => {
  if (!skillLevel) {
    return DEFAULT_SKILL_ICON
  }
  return (
    SKILL_ICON_BY_VALUE[skillLevel.trim().toLowerCase()] ?? DEFAULT_SKILL_ICON
  )
}
